module.exports = __webpack_public_path__ + "static/media/Currency-Accounts-Platform.0419b704.png";